import React from 'react'

const DeleteAccountInstructions = () => {
  return (
    <div>
        <h4>HOW TO DELETE YOUR ACCOUNT</h4>
        <p>Step -1 Login into your app</p>
        <p>Step -2 Copy your Admission Number</p>
        <p>Step -3 Open gmail and mail to gouthamp0306@gmail.com For account deletion by pasting your Admission number</p>
    </div>
  )
}

export default DeleteAccountInstructions